import { IUser } from "data/user";
import React from "react";
import { useRecoilState } from "recoil";
import { userState } from "recoil/atoms";
import { deleteToken, post, setToken } from "utils/ApiUtil";

export default function useUser() {
  const [user, setUser] = useRecoilState(userState);

  async function login({
    sns_id,
    sns_type,
  }: {
    sns_id: string;
    sns_type: string;
  }) {
    const result = {
      success: false,
      message: "오류",
    };

    try {
      const {
        data,
        message,
        success: loginSuccess,
      } = await post(`/api/user/login`, { sns_id, sns_type });
      const appToken = data?.token?.token;
      if (loginSuccess && !!appToken) {
        await setToken(appToken);
        getUser();
      }
      result.success = loginSuccess;
      result.message = message;
    } catch (error) {
      console.error("useUser login error", error);
    }
    return result;
  }

  async function getUser() {
    try {
      const { data, success } = await post<IUser>("/api/user/get-user");
      if (!!success && !!data) {
        setUser(data);
      } else if (!success) {
        logOut();
      }
    } catch (error) {
      console.error("useUser getUser error", error);
    }
  }

  async function logOut() {
    try {
      await deleteToken();
      setUser(undefined);
    } catch (error) {
      console.error("useUser logOut error", error);
    }
  }

  return {
    user,
    getUser,
    login,
    logOut,
  };
}
